import React, { useEffect, useState, memo } from "react";

import DefaultNote from 'core/assets/icons/note/default_note.svg';
import ActiveNote from 'core/assets/icons/note/active_note.svg';
import DefaultNote2 from 'core/assets/icons/note/default_note_2.svg';
import { useFavorite, useUpdateFavoriteList } from "modules/Favorites/hooks";
import CDialog from "../CDialog";
import { _t } from "core/language";
import { useAuthModal } from "core/context";
import { useDispatch, useSelector } from "react-redux";
import { updateFavoriteList } from "modules/Favorites/store/actions";

export type IProps = {
  active?: boolean,
  id: number,
  onChange?: (id: number, state: boolean) => void,
  type?: 'nonText' | 'hasText',
  className?: string;
  showConfirmRemoveNote?: boolean;
  reload?: (cb: any) => void;
  recipeRequestId?: string | number | null | undefined;
};

const NoteItem = ({
  id,
  onChange,
  active = false,
  type = 'nonText',
  className,
  showConfirmRemoveNote,
  reload,
  recipeRequestId,
}: IProps) => {
  const dispatch = useDispatch();
  const { openModal, token } = useAuthModal();
  const { handleFavorite } = useFavorite()
  const [ stateActive, setStateActive ] = useState<boolean>(active);
  const [ stateDialog, setStateDialog ] = useState({
    state:false,
  });
  const { updateList } = useUpdateFavoriteList()
  const { dataList } = useSelector((state: any) => state.Favorites || {});
  const [ itemFavoriteTerm, setItemFavoriteTerm] = useState<any>('');

  useEffect(() => {
    setStateActive(active)
  }, [active, id])

  const toggleFavorite = () => {
    if(!showConfirmRemoveNote){
      setStateActive((p: boolean) => !p)
    }
    onChange?.(id, !stateActive)
    handleFavorite({
      id: String(id),
      stateActive: !stateActive,
      recipe_request_id: recipeRequestId,
    })
    if(stateActive){
      const itemFind = dataList.filter((item:any) => item?.id === id);
      // console.log(itemFavoriteTerm,'itemFavoriteTerm')
      if(itemFind.length){
        setItemFavoriteTerm(itemFind[0])
      }
      if(id){
        updateList(id, recipeRequestId)
      }
    }else {
      if(itemFavoriteTerm){
        const updatedList = [itemFavoriteTerm,...dataList];
        const listFavoriteMap = {data:updatedList}
        dispatch(updateFavoriteList(listFavoriteMap));
      }
    }
  }

  const _handleClickNote = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();

    if (!token) {
      openModal(() => {
        reload?.((newState: boolean) => {
          if (!newState) {
            document.getElementById(`NoteItem-${id}`)?.click()
          }
        })
      });
      return;
    }

    if (stateActive && showConfirmRemoveNote) {
      setStateDialog({
        state:true,
      })
    } else {
      toggleFavorite()
    }
  };

  const handleUnSaveFavorite = () => {
    toggleFavorite()
    onCloseConfirmModal()
  }

  const onCloseConfirmModal = () => {
    setStateDialog((p: any) => ({
      ...p,
      state: false
    }))
  }

  return (
    <>
      {type === 'nonText' ? (
        <span
          className={`absolute top-2 right-2 ${className}`}
          onClick={_handleClickNote}
          id={`NoteItem-${id}`}
        >
          <img src={stateActive ? ActiveNote : DefaultNote} alt={'favorite'} />
        </span>
      ) : (
        <span
          className={className}
          onClick={_handleClickNote}
          id={`NoteItem-${id}`}
        >
          <img src={stateActive ? ActiveNote : DefaultNote2} alt={'favorite'} />
          <label className="text-[9px] block mt-1 font-medium whitespace-nowrap">
            {stateActive ? _t('favorites.unsave') : _t('favorites.save')}
          </label>
        </span>
      )}

      <CDialog
        open={stateDialog?.state}
        handleSubmit={handleUnSaveFavorite}
        closeModal={onCloseConfirmModal}
        classNamechildren={'pb-[20px]'}
        closeText={_t('favorites.CloseFavorite')}
        submitText={_t('favorites.OkFavorite')}
      >
        <p className="text-sm font-medium ">
          {_t('favorites.LabelDoYouWantUnSave')}
        </p>
      </CDialog>
    </>
  );
};


export default memo(NoteItem);
